import settings from './settings.json';
const { ns } = settings;
export { ns };
